import { render } from "./VerifyAccount.vue?vue&type=template&id=8dc7341e&ts=true"
import script from "./VerifyAccount.vue?vue&type=script&lang=ts"
export * from "./VerifyAccount.vue?vue&type=script&lang=ts"

import "./VerifyAccount.vue?vue&type=style&index=0&id=8dc7341e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__